module.exports = require("core-js/library/fn/object/entries");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/object/entries.js
 ** module id = 341
 ** module chunks = 0
 **/